import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import { hasRecordReference, isDependencyConnector } from '../objects/guards';
import trackEvent from '../utils/analytics';

class ToolAddDependencyLines extends Tool {
  static toolName = 'Show dependency lines';

  static available({ controller }: IToolAvailableInput) {
    const canvasObjects = controller.canvas.getObjects();
    // Only available if record linking is allowed, there
    // are some records on the board and there are no
    // existing dependency lines
    return (
      controller.allowRecordLinking() &&
      canvasObjects.some(hasRecordReference) &&
      !canvasObjects.some(isDependencyConnector)
    );
  }

  static enabled({ controller }: IToolEnabledInput) {
    return ToolAddDependencyLines.available({ controller });
  }

  static action({ controller }: IToolActionInput) {
    controller.dependencyLineManager.refreshDependencyLines();
    trackEvent(
      'Feature-7229119605601784574',
      'User shows whiteboard dependency lines'
    );
  }

  static buttonComponent() {
    return simpleToolButton(
      ToolAddDependencyLines,
      'fa-regular fa-arrows-turn-to-dots'
    );
  }
}

export default ToolAddDependencyLines;
